<div class="activity d-print-none" [hidden]="!isLoading">
  <ngb-progressbar type="success" [value]="100" [striped]="true" height="5px" [animated]="true"></ngb-progressbar>
</div>
<div class="errorContainer d-print-none">
  <app-notification [toast]="toast" *ngFor="let toast of toastService.Toasts"></app-notification>
  <app-import-dropdown></app-import-dropdown>
</div>
<nav class="navbar navbar-dark bg-dark navbar-expand-lg d-print-none">
  <div class="container-fluid">
    <a class="navbar-toggler" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">
      <span class="navbar-toggler-icon"></span>
    </a>
    <a [routerLink]="homeRoute" class="navbar-brand">SIDR Online</a>
    <ng-container *ngIf="fullLogin">
      <span class="navbar-text me-auto">
        <district-name></district-name>
      </span>
    </ng-container>
    <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item" ngbDropdown>
          <a class="dropdown-toggle nav-link" role="button" ngbDropdownToggle>
            <span class="bi bi-circle-half">&nbsp;</span>
          </a>
          <div ngbDropdownMenu style="z-index: 1021;">
            <button class="dropdown-item" (click)="toggleDarkMode('auto')" [ngClass]="{'active':theme === 'auto'}">
              <span class="bi bi-circle-half"></span> Auto
            </button>
            <button class="dropdown-item" (click)="toggleDarkMode('light')" [ngClass]="{'active':theme === 'light'}">
              <span class="bi bi-sun-fill"></span> Light
            </button>
            <button class="dropdown-item" (click)="toggleDarkMode('dark')"  [ngClass]="{'active':theme === 'dark'}">
              <span class="bi bi-moon-fill"></span> Dark
            </button>
          </div>
        </li>
        <li class="nav-item" *ngIf="!isLoggedIn">
          <a href="https://info.sidronline.com" class="nav-link" role="link">Request a Demo</a>
        </li>
        <ng-container *ngIf="fullLogin">
          <li class="nav-item">
            <student-search class="d-print-none"></student-search>
          </li>
        </ng-container>
      </ul>
      <login class="d-print-none"></login>
    </div>
  </div>
</nav>
<div class="grid-container bg-body-tertiary">
  <div class="grid-content">
    <router-outlet></router-outlet>
    <div class="container d-print-none">
      <div class="row p-2">
        <div class="col-md text-center">
          <a [routerLink]="['/privacy']">Privacy Policy</a>
        </div>
        <div [isSignedIn]="false" class="col-md text-center">
          <a [routerLink]="['/demo']">Request a Demo</a>
        </div>
      </div>
    </div>
  </div>
</div>
